import { Component, Input } from '@angular/core';
import { BackgroundImageDirective } from '../../directives/background-image/background-image';

/**
 * Generated class for the ProductoListaComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'categoria',
  templateUrl: 'categoria.html'
})
export class CategoriaComponent {

  @Input('producto') producto: any;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/categoria/categoria.ts